export default {
  title: "Currencies",
  subtitle: "Manage currencies and exchange rates",
  
  // Actions
  addNew: "Add New Currency",
  createCurrency: "Create Currency",
  editCurrency: "Edit Currency",
  deleteCurrency: "Delete Currency",
  currencyDetails: "Currency Details",

  actions: {
    back: "Back",
    update: "Update",
    updating: "Updating...",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    creating: "Creating..."
  },
  
  // Fields
  fields: {
    name: "Currency Name",
    code: "Currency Code",
    symbol: "Symbol",
    exchangeRate: "Exchange Rate",
    lastExchangeRate: "Last Exchange Rate",
    isBaseCurrency: "Base Currency",
    status: "Status",
    hedge: "Hedge",
    createdAt: "Created At",
    updatedAt: "Updated At"
  },
  
  // Placeholders
  placeholders: {
    name: "Enter currency name",
    code: "Enter currency code (e.g., USD)",
    symbol: "Enter currency symbol (e.g., $)",
    exchangeRate: "Enter exchange rate",
    lastExchangeRate: "Enter last exchange rate",
    hedge: "Enter hedge value"
  },
  
  // Messages
  messages: {
    createSuccess: "Currency created successfully",
    createError: "Failed to create currency",
    updateSuccess: "Currency updated successfully",
    updateError: "Failed to update currency",
    deleteSuccess: "Currency deleted successfully",
    deleteError: "Failed to delete currency",
    deleteConfirm: "Are you sure you want to delete this currency?",
    noCurrencies: "No currencies found",
    loadingCurrencies: "Loading currencies...",
    fetchError: "Failed to fetch currencies",
    exchangeCreateSuccess: "Exchange rate created successfully",
    exchangeCreateError: "Failed to create exchange rate"
  },
  
  // Validation
  validation: {
    nameRequired: "Currency name is required",
    nameMinLength: "Currency name must be at least 2 characters",
    nameMaxLength: "Currency name must not exceed 100 characters",
    codeRequired: "Currency code is required",
    codeFormat: "Currency code must be 3 characters (e.g., USD)",
    symbolRequired: "Currency symbol is required",
    hedgeRequired: "Hedge value is required",
    exchangeRateRequired: "Exchange rate is required",
    exchangeRateMin: "Exchange rate must be greater than 0",
    exchangeRateMax: "Exchange rate must not exceed 999999",
    fillAllFields: "Please fill in all required fields"
  },
  
  // Table headers
  table: {
    name: "Name",
    code: "Code",
    symbol: "Symbol",
    exchangeRate: "Exchange Rate",
    lastExchangeRate: "Last Rate",
    isBaseCurrency: "Base Currency",
    status: "Status",
    actions: "Actions",
    hedge: "Hedge"
  },
  
  // Status options
  statusOptions: {
    active: "Active",
    inactive: "Inactive"
  },
  
  // Base currency options
  baseCurrencyOptions: {
    yes: "Yes",
    no: "No"
  },
  
  // Exchange Rate
  exchangeRate: {
    addNew: "Add New Exchange Rate",
    history: "Exchange Rate History",
    date: "Date",
    rate: "Rate",
    ratePlaceholder: "Enter exchange rate",
    noRates: "No exchange rates found"
  },

  // Breadcrumbs
  breadcrumbs: {
    currencies: "Currencies",
    create: "Create Currency",
    edit: "Edit Currency",
    view: "View Currency"
  }
};
